<div class="or-d-flex or-flex-col">
  @for (game of games; track game.gameId) {
    <div
      class="or-p-16-px or-mb-8-px"
      [ngClass]="isSelected(game.gameId) ? 'is-active or-bg-focus' : 'is-no-active or-bg-white'">
      <ion-checkbox
        labelPlacement="end"
        justify="start"
        class="or-w-100-pc"
        [checked]="isSelected(game.gameId)"
        (ionChange)="toggle(game.gameId)">
        <div [ngClass]="isSelected(game.gameId) ? 'or-head-xs or-color-main-1' : 'or-text-sm or-color-black'">
          {{ game.label }}
        </div>
      </ion-checkbox>
    </div>
  }
</div>
